import {
  MultiDatePicker,
  MultiDatePicker_Range,
} from 'components/MyDatePicker/MultiDatePicker';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment-jalaali';
import React, { MouseEvent } from 'react';
import { MapDispatchToProps, MapStateToProps, connect } from 'react-redux';
import * as taskManipulate from 'store/tasks/taskManipulate';
import { createTaskFromTemplate } from 'store/tasks/taskManipulate2';
import { IUsers, RootState } from 'store/store';
import required from '../../assets/images/required.svg';
import taskMessages from '../../containers/Tasks/TasksManagement/Messages';
import Button from '../Button';
import Dropdown from '../Dropdown';
import { display } from '../ErrorView/ErrorDialog';
import Icon from '../Icon';
import messages from './Messages';
import { TaskItem, TaskItemBody, TemplateDropdownWrapper } from './styles';
// import ClassicEditor from '@rastech-inc/ckeditor';
import { navigate } from '@reach/router';
import {
  TaskBody,
  UsersList,
  WeightInput,
} from 'containers/Tasks/TasksManagement/styles';
import { getMembershipInfo } from 'containers/Tasks/TasksManagement/TaskEditor';
import TaskFilePicker from 'containers/Tasks/TasksManagement/TaskFilePicker';
import CKEditorField, {
  CkEditorBaseConfig,
} from '../CKEditorField/CKEditorField';
import Select from '../Select';
import { IOption } from '../Select/Select';
import { TaskOptionsIcon } from '../TaskEditorHeader/styles';
import { ItemWrapper, TaskWrapper } from './styles';
import UserSelector from '../UserSelector';
import { IRoleOption, IUserOption } from '../UserSelector/UserSelector';
import { appDispatch } from 'store/store';
import { IThisUserState } from 'store/thisUser/thisUserSlice';
import {
  HiddenFieldValue,
  IAssignmentView,
  IField,
  ITask,
  ITasks,
  IUserTaskRelView,
  TaskStatus,
} from 'store/tasks/tasksType';
import {
  ICompany,
  ICompanyProviders,
  IProjectStore,
} from 'store/companies/companiesTypes';
import { createTask, createTaskFn } from 'store/tasks/tasksSlice';
import { AssignmentType, TimeType } from 'store/entity/types';
import { IRelatedProviderItem } from 'store/providers/providerTypes';
import { englishNumber } from 'utils/number';
import { getAccessToken } from '../../api/Utils';
import Input from '../Input';
import { WindowSize } from '../TaskListView/TaskListView';
import i18n, { languageDirection } from '../../i18n';
import { getLanguageBaseOnTZ } from '../../utils/LanguageLocalStorage';
import { black } from 'utils/style/colors';

moment.loadPersian({ dialect: 'persian-modern' });

const { Menu, MenuItem } = Dropdown;

interface IOwnProps {
  templates: ITasks;
  siblings: ITasks;
  thisUser: IThisUserState;
  parent: ITask;
  companyId: number;
  thisUserId: number;
  project: IProjectStore;
  showWeight?: boolean;
  onSaveTask: (taskView: ITask) => void;
  companyOwnerId: number;
  members: { [key: number]: IUserOption | IRoleOption };
  windowSize: WindowSize;
}

interface StateToProps {
  users: IUsers['map'];
  relatedProviders: ICompanyProviders | null;
  companyRoles: ICompany['roles'];
  company: ICompany;
  token?: string;
}

type DispatchToProps = {
  createTask: (
    task: ITask,
    dontSendMessages?: boolean
  ) => ReturnType<typeof createTaskFn>;
};

type IComponentProps = IOwnProps & StateToProps & DispatchToProps;

interface IComponentStates {
  showWeightPopover: boolean;
  showProgressPopover: boolean;
  adding: boolean;
  loadingSave: boolean;
  task: ITask;
  showDateModal: TimeType | 'none';
  showDropdown: boolean;
  expanded: boolean;
}

class TaskListNew extends React.PureComponent<
  IComponentProps,
  IComponentStates
> {
  static defaultProps = {
    showWeight: false,
  };

  state: IComponentStates = {
    showWeightPopover: false,
    showProgressPopover: false,
    task: Object.values(this.props.templates.data)[0],
    adding: false,
    loadingSave: false,
    showDateModal: 'none' as const,
    showDropdown: false,
    expanded: true,
  };

  handleAddExternalSubTask = (templateId: number | string) => {
    const projectId = this.props.project.id;
    const companyId = this.props.companyId;
    if (this.props.parent && this.props.templates.data[templateId].draft) {
      const pureTask = createTaskFromTemplate(
        this.props.templates.data[templateId],
        this.props.users,
        this.props.project,
        this.props.company as ICompany,
        this.props.parent
      );
      this.handleSaveTask(pureTask)?.then((res) => {
        const newTaskId = res.id;
        const queryParams = new URLSearchParams({ editting: 'true' });
        const projectPart = window.location.href.includes('/project/')
          ? `project/${projectId}/`
          : '';
        navigate(
          `/t/${companyId}/${projectPart}task/editor/${newTaskId}/info?${queryParams.toString()}`
        );
      });
    } else {
      const parentId = this.props.parent.id;
      const projectPart = window.location.href.includes('/project/')
        ? `project/${projectId}/`
        : '';
      navigate(
        `/t/${companyId}/${projectPart}task/editor/new/info?template=${templateId}&parent=${parentId}`
      );
    }
  };

  handleSaveTask = (task: ITask, createNext: boolean = false) => {
    const newTask = taskManipulate.stateToServer(task);
    if (newTask.templateReportOptions) {
      delete newTask.templateReportOptions;
    }
    this.setState({ loadingSave: true });
    return this.props
      .createTask(newTask)
      .then((res) => {
        if (!createNext || task.singleInParent) {
          this.setState({ loadingSave: false, adding: false });
        } else {
          this.setState({ loadingSave: false });
        }
        return Promise.resolve(res.createdTask);
      })
      .catch((err) => {
        this.setState({ loadingSave: false });
        display(err);
        return Promise.reject();
      });
  };

  handleSaveRelatedProviderItems = (providerItem: IRelatedProviderItem) => {
    const task = cloneDeep(this.state.task!);
    const relatedProviderItems = task.relatedProviderItems;
    if (relatedProviderItems) {
      task.relatedProviderItems = [...relatedProviderItems, providerItem];
    } else {
      task.relatedProviderItems = [providerItem];
    }
    this.setState({ task });
  };

  handleRemoveProviderItem =
    (item: IRelatedProviderItem) => (e: MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      const task = cloneDeep(this.state.task!);
      const relatedProviderItems = task.relatedProviderItems;
      if (relatedProviderItems) {
        task.relatedProviderItems = relatedProviderItems.filter(
          (relatedItem) => relatedItem.id !== item.id
        );
        this.setState({ task });
      }
    };

  handleChangeVerifier =
    (
      type: AssignmentType,
      field: 'verifier' | 'taskPublisher' | 'subTaskPublisher'
    ) =>
    (values: Array<IUserOption | IRoleOption>) => {
      const { project, company } = this.props;
      const task = cloneDeep(this.state.task!);
      let verifier: IAssignmentView | null = null;
      if (values.length !== 0 && values[0].optionType === 'user') {
        const userValue = values[0] as IUserOption;
        const {
          projectMembership,
          roleIdFromProjectMembership,
          roleNameFromProjectMembership,
        } = getMembershipInfo(project, userValue, company!, task);
        verifier = {
          userId: userValue.userId,
          status: userValue.status ? userValue.status : 'notStarted',
          type: type,
          progress: userValue.progress ? userValue.progress : 0,
          taskId: task.template ? undefined : (task.id as number),
          properties: {
            roleId: userValue.relatedRoleId || roleIdFromProjectMembership,
            roleName:
              userValue.relatedRoleName || roleNameFromProjectMembership,
            implicit: projectMembership?.implicit,
            title: projectMembership?.title,
            projectRoleId: projectMembership?.projectRoleId,
          },
        };
      }
      task[field] = verifier;
      this.setState({ task });
    };

  handleChangeVerifyProgress = (
    userId: number,
    progress: string,
    status: TaskStatus
  ) => {
    const task = cloneDeep(this.state.task);
    if (task.verifiers && task.verifiers[userId]) {
      task.verifiers[userId].progress = Number(progress);
      task.verifiers[userId].status = status;
    }
    this.setState({ task });
  };

  handleChangeFollowers = (values: Array<IUserOption | IRoleOption>) => {
    const task = cloneDeep(this.state.task!);
    task.followers = values.reduce((list: IUserTaskRelView[], value) => {
      if (value.optionType === 'user') {
        const user = Object.values(task.followers).find(
          (follower: IUserTaskRelView) => follower.userId === value.userId
        );
        const item: IUserTaskRelView = {
          userId: value.userId,
          taskId: task.template ? undefined : (task.id as number),
          canEdit: user ? user.canEdit : task.followerCanEdit,
        };
        list.push(item);
      }
      return list;
    }, []);
    this.setState({ task });
  };

  wrapper: React.RefObject<HTMLDivElement> = React.createRef();
  title: React.RefObject<HTMLSpanElement> = React.createRef();
  date: React.RefObject<HTMLDivElement> = React.createRef();

  handleChangeTitle = (value: string) => {
    let task = this.state.task;
    if (task) {
      task = cloneDeep(task);
      task.title = value;
      this.setState({ task });
    }
  };

  titleEditor: any = {};

  handleClickOnWeight = () => {
    this.setState({ showWeightPopover: !this.state.showWeightPopover });
  };

  handleAddSubTask = (templateId?: number | string) => {
    const task = this.state.task;
    if (templateId) {
      if (!this.state.adding || !task!.title) {
        this.createTaskFromTemplate(templateId);
      } else {
        if (task!.title && task!.title.trim()) {
          task!.title = task!.title.trim();
          this.handleSaveTask(task, true).then((_) => {
            this.createTaskFromTemplate(templateId);
            const editor = this.titleEditor;
            editor.setData('');
          });
        }
      }
    } else {
      this.setState({ showDropdown: true });
    }
  };

  handleClickOnTemplateItem = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    this.setState({ showDropdown: false });
    const {
      currentTarget: {
        dataset: { templateId },
      },
    } = e;
    if (templateId) {
      this.handleAddSubTask(templateId);
    }
  };

  createTaskFromTemplate = (templateId: number | string) => {
    const template = this.props.templates.data[Number(templateId)];
    if (template?.disallowQuickAdd) {
      this.handleAddExternalSubTask(templateId);
      return;
    }
    const task = createTaskFromTemplate(
      template,
      this.props.users,
      this.props.project,
      this.props.company,
      this.props.parent
    );

    setTimeout(() => {
      this.setState((_: IComponentStates) => ({
        adding: true,
        task,
      }));
    }, 250);
  };

  handleChangeFieldValue = (name: string, values: IOption[]) => {
    const task = cloneDeep(this.state.task!);
    const index = task.fields.findIndex((item) => item.name === name);
    task.fields[index].value = values.reduce((current, item) => {
      if (current) current = current + ',';
      current = current + item.value;
      return current;
    }, '');
    this.setState({ task });
  };

  handleFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const task = cloneDeep(this.state.task!);
    const index = task.fields.findIndex(
      (item) => item.name === event.target.name
    );
    task.fields[index].value = event.target.value;
    this.setState({ task });
  };

  handleHTMLFieldChange = (index: number, value: string, name: string) => {
    const task = cloneDeep(this.state.task!);
    if (index === -1) {
      task.title = value.replaceAll(
        /<(?!\/?(span|mark)(?=>|\s.*>))\/?.*?>/g,
        ''
      );
    } else {
      const index = task.fields.findIndex((item) => item.name === name);
      task.fields[index].value = value;
    }
    this.setState({ task });
  };

  handleClickOnDate =
    (dateType: 'none' | TimeType, editable: boolean) => () => {
      if (editable) {
        this.setState({ showDateModal: dateType });
      }
    };
  handleRemoveDate = (dateType: TimeType) => () => {
    this.setState((prevState) => {
      const task = cloneDeep(prevState.task);
      task![dateType] = undefined;
      return { task, showDateModal: 'none' };
    });
  };

  setDate = (value: { startDate?: number | null; dueDate?: number | null }) => {
    const task = cloneDeep(this.state.task);

    task['startDate'] = value?.startDate || undefined;
    task['dueDate'] = value?.dueDate || undefined;

    this.setState({
      task: { ...task },
      showDateModal: 'none',
    });
  };

  handleChangeAssignee = (values: Array<IUserOption | IRoleOption>) => {
    const task = cloneDeep(this.state.task);
    const { project, company } = this.props;
    if (task) {
      task.assignee = values.reduce((list: any, value) => {
        if (value.optionType === 'user') {
          const {
            projectMembership,
            currentAssignee,
            roleIdFromProjectMembership,
            roleNameFromProjectMembership,
          } = getMembershipInfo(project, value, company!, task);
          list.push({
            userId: value.userId,
            status: currentAssignee ? currentAssignee.status : 'notStarted',
            type: 'does',
            progress: currentAssignee ? currentAssignee.progress : 0,
            taskId: task!.template ? undefined : (task!.id as number),
            properties: {
              roleId: roleIdFromProjectMembership || value.relatedRoleId,
              roleName: roleNameFromProjectMembership || value.relatedRoleName,
              implicit: projectMembership?.implicit,
              title: projectMembership?.title,
              projectRoleId: projectMembership?.projectRoleId,
            },
          });
        }
        return list;
      }, []);
      this.setState({ task });
    }
  };

  handleChangeVerifiers = (values: Array<IUserOption | IRoleOption>) => {
    const task = cloneDeep(this.state.task);
    const { project, company } = this.props;
    if (task) {
      task.verifiers = values.reduce((list: any, value) => {
        if (value.optionType === 'user') {
          const {
            projectMembership,
            currentAssignee,
            roleIdFromProjectMembership,
            roleNameFromProjectMembership,
          } = getMembershipInfo(project, value, company!, task);
          list.push({
            userId: value.userId,
            status: currentAssignee ? currentAssignee.status : 'notStarted',
            type: 'verify',
            progress: currentAssignee ? currentAssignee.progress : 0,
            taskId: task!.template ? undefined : (task!.id as number),
            properties: {
              roleId: roleIdFromProjectMembership || value.relatedRoleId,
              roleName: roleNameFromProjectMembership || value.relatedRoleName,
              implicit: projectMembership?.implicit,
              title: projectMembership?.title,
              projectRoleId: projectMembership?.projectRoleId,
            },
          });
        }
        return list;
      }, []);
      this.setState({ task });
    }
  };

  projectMembersId: number[] | undefined;

  componentDidUpdate(): void {
    if (this.props.project) {
      const memberIdsSet = Object.values(
        this.props.project.projectMembers || {}
      )!.reduce((memberIds: Set<number>, member) => {
        if (!member.implicit) {
          memberIds.add(member.userId!);
        }
        return memberIds;
      }, new Set<number>());
      // add users from role members
      Object.values(this.props.project.projectRoleMembers || {})!.reduce(
        (memberIds: Set<number>, member) => {
          if (!member.implicit) {
            this.props.companyRoles[member.roleId!].users.forEach((r) => {
              memberIds.add(r.userId);
            });
          }
          return memberIds;
        },
        memberIdsSet
      );
      this.projectMembersId = Array.from(memberIdsSet);
    }
  }

  onEnterPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.keyCode === 13 && (e.ctrlKey || e.metaKey)) {
      e.preventDefault();
      if (!this.state.loadingSave)
        this.handleAddSubTask(this.state.task!.templateId);
      return true;
    }
    return false;
  };

  cancel = () => {
    this.setState({ adding: false });
  };

  handleShowDropdown = (showDropdown: boolean) => {
    this.setState({ showDropdown });
  };

  setTitleEditor = (editor: any) => {
    this.titleEditor = editor;
    // editor.on('keyup', this.onEnterPress);
    // editor.on('change', this.onEnterPress);
    // editor.keystrokes.set('Ctrl+Enter', () => {
    //   console.log('Ctrl+Enter has been pressed');
    // });
    editor.editing.view.document.on('enter', (_: any, domEventData: any) => {
      if (this.onEnterPress(domEventData.domEvent)) {
        domEventData.preventDefault();
        domEventData.stopPropagation();
      }
    });
  };
  render() {
    const { task, adding, loadingSave, expanded } = this.state;
    const {
      templates,
      parent,
      members,
      project,
      relatedProviders,
      siblings,
      windowSize,
    } = this.props;
    const fieldClass =
      windowSize === 'small'
        ? 'col s12 l12 m12'
        : windowSize === 'medium'
          ? 'col s6 m6 l6'
          : 'col s4 m4 l4';
    const availableTemplates = Object.values(templates.data).reduce(
      (items, t: ITask) => {
        if (t) {
          const item = { id: t.id, title: t.taskName };
          if (
            !t.singleInParent ||
            !siblings ||
            Object.values(siblings).find((it) => it!.templateId === t.id) ===
              undefined
          )
            items.push(item);
        }
        return items;
      },
      [] as Array<{
        id: number;
        title: string;
      }>
    );
    const listOfRequiredFields =
      this.state.task?.draft || this.state.task?.taskIsReadyToPublish
        ? []
        : this.state.task?.requiredFields;

    const checkRequiredFieldsFulfilled = () => {
      const task = this.state.task;

      const fieldMappings: { [key: string]: any } = {
        assignee: task.assignee,
        verifier:
          Object.keys(task.verifiers || {}).length > 0 ? task.verifiers : null,
        follower: task.followers,
        publisher: task.taskPublisher,
        subtaskPublisher: task.subTaskPublisher,
        startDate: task.startDate,
        dueDate: task.dueDate,
        relatedItem:
          (task.relatedProviderItems || []).length > 0
            ? task.relatedProviderItems
            : null,
      };

      return (
        listOfRequiredFields?.every((field) => fieldMappings[field]) ?? true
      );
    };

    const returnJSXOfFields = (field: IField, index: number) => {
      if (field.value === HiddenFieldValue) return <></>;
      if (field.type === 'html') {
        return (
          <div style={{ flex: '1', flexBasis: '100%' }}>
            <CKEditorField
              key={field.name}
              id={field.name}
              label={
                <div key={index} className="row" style={{ width: '100%' }}>
                  <div
                    className="row"
                    style={{
                      fontSize: '1rem',
                      fontWeight: 'bold',
                      paddingInlineStart: '0.5rem',
                      margin: '0.5rem 0',
                      color: black,
                    }}
                  >
                    {field.title}
                  </div>
                </div>
              }
              data={
                fields.find((item) => item.name === field.name)?.value || ''
              }
              onChange={(data: string) => {
                this.handleHTMLFieldChange(index, data, field.name);
              }}
              dir={languageDirection()}
              config={CkEditorBaseConfig(this.props.token)}
            />
          </div>
        );
      } else {
        return field.options && Object.values(field.options).length > 0 ? (
          <div
            key={index}
            className={fieldClass}
            style={{ margin: '0', marginTop: '1rem' }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {field.required && (
                <img
                  src={required}
                  className={
                    !field.value || /^\s*$/.test(field.value)
                      ? 'filter-red'
                      : ''
                  }
                  style={{
                    padding: '7px',
                  }}
                />
              )}
              <div>{field.title}</div>
            </div>
            <Select
              // label={(field.required ? '* ' : '') + field.title}
              isRequired={field?.required}
              values={(field.type === 'multiSelect'
                ? (field.value || '').split(',')
                : [field.value || '']
              ).reduce((current: IOption[], item) => {
                if (item)
                  current.push({
                    label: item,
                    value: item,
                  });
                return current;
              }, [] as IOption[])}
              options={Object.values(field.options)
                .sort((a, b) => {
                  if (a < b) {
                    return -1;
                  }
                  if (a > b) {
                    return 1;
                  }
                  return 0;
                })
                .reduce((current: IOption[], item) => {
                  current.push({
                    label: item,
                    value: item,
                  });
                  return current;
                }, [] as IOption[])}
              onChangeValues={(values) =>
                this.handleChangeFieldValue(field.name, values)
              }
              multiChoice={field.type === 'multiSelect'}
            />
          </div>
        ) : field.type === 'date' ? (
          <div
            key={index}
            className={fieldClass}
            style={{ margin: '0', marginTop: '1rem' }}
          >
            <MultiDatePicker
              label={field.title}
              id={field.name}
              setDate={(value) => {
                const task = cloneDeep(this.state.task!);
                const index = task.fields.findIndex(
                  (item) => item.name === field.name
                );
                task.fields[index].value = value?.toString() || '0';
                this.setState({ task });
              }}
              value={
                Number(
                  fields.find((item) => item.name === field.name)?.value
                ) || new Date().valueOf()
              }
            />
          </div>
        ) : (
          <div
            key={index}
            className={fieldClass}
            style={{ margin: '0', marginTop: '1rem' }}
          >
            <Input
              title={field.title}
              key={index}
              id={field.name}
              name={field.name}
              type="text"
              value={
                fields.find((item) => item.name === field.name)?.value || ''
              }
              placeholder={field.title}
              onChange={this.handleFieldChange}
              required={!!required}
            />
          </div>
        );
      }
    };

    const {
      fields,
      haveFollower,
      haveAssignee,
      relatedProviderItemTitle,
      relatedProviderItems,
      haveRelatedItem,
      followersTitle,
      followers,
      haveVerifier,
      haveTaskPublisher,
      haveSubTaskPublisher,
      verifierTitle,
      taskPublisherTitle,
      subTaskPublisherTitle,
      taskPublisher,
      subTaskPublisher,
      weight,
    } = task || {};
    const imTask = task;
    const hasEmptyRequiredField = fields?.find(
      (field) => field.required && (!field.value || /^\s*$/.test(field.value))
    );

    return (
      <div>
        {adding && task && availableTemplates.length > 0 && (
          <TaskWrapper draft={task && task.draft}>
            <ItemWrapper active={false} draft={task && task.draft}>
              <TaskItem>
                <TaskItemBody>
                  <TaskOptionsIcon
                    type="x"
                    onClick={() => {
                      if (!loadingSave) this.cancel();
                    }}
                    style={{ margin: '0 0 0 0.8em' }}
                  />
                  <CKEditorField
                    key={'title'}
                    id={'title'}
                    // editor={ClassicEditor}
                    // data={task.title}
                    onChange={(data: string) => {
                      this.handleHTMLFieldChange(-1, data, '');
                    }}
                    dir={languageDirection()}
                    config={{
                      toolbar: ['fontColor', 'highlight', '|', 'speech'],
                      language: getLanguageBaseOnTZ(),
                      balloonToolbar: ['fontColor', 'highlight'],
                      placeholder: messages.taskTemplateName(task.taskName),
                    }}
                    onReady={(editor: any) => {
                      this.setTitleEditor(editor);
                    }}
                    wrapperStyle={{
                      flexGrow: 1,
                    }}
                  />
                  {task.haveWeight && (
                    <WeightInput
                      id="weight"
                      type="number"
                      step="any"
                      min="0"
                      name="weight"
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        this.setState({
                          task: {
                            ...task,
                            weight: Number(englishNumber(e.target.value)),
                          },
                        });
                      }}
                      value={weight}
                      label={
                        i18n.t('taskWeight', { ns: 'taskManager' }) as string
                      }
                      placeholder={
                        i18n.t('taskWeight', { ns: 'taskManager' }) as string
                      }
                      wrapperClassName="question-input-small"
                    />
                  )}
                  <TaskOptionsIcon
                    type={expanded ? 'chevron-up' : 'chevron-down'}
                    onClick={() => {
                      this.setState({ expanded: !expanded });
                    }}
                    style={{ margin: '0 0.8em 0 0 ' }}
                  />
                </TaskItemBody>
                <TaskItemBody style={{ flexWrap: 'wrap' }}>
                  {haveAssignee && (
                    <div
                      style={{
                        minWidth: '6rem',
                        flexGrow: 1,
                      }}
                    >
                      <span
                        style={{
                          display: 'inline-block',
                          fontWeight: 'bold',
                          fontSize: '1rem',
                          paddingInlineStart: '0.25rem',
                          margin: '0.5rem 0',
                        }}
                      >
                        {`${listOfRequiredFields?.includes('assignee') ? '*' : ''} ${messages.assignee(task.assigneeTitle)}
                    `}
                      </span>
                      <UserSelector
                        label={messages.assignee(task.assigneeTitle)}
                        onChangeValues={this.handleChangeAssignee}
                        values={Object.values(task.assignee).reduce(
                          (list: IUserOption[], value) => {
                            const userMember = members[
                              `USER_${value['userId']}`
                            ] as IUserOption;
                            const item: IUserOption = {
                              userId: value['userId'],
                              name: userMember.name,
                              roles: userMember.roles,
                              progress: value['progress'],
                              progressDescription: value.progressDescription,
                              optionType: 'user',
                              status: value['status']
                                ? value['status']
                                : 'notStarted',
                              relatedRoleId: value.properties?.roleId,
                              relatedRoleName: value.properties?.roleName,
                              assignmentId: value?.id,
                            };
                            list.push(item);
                            return list;
                          },
                          []
                        )}
                        usePop={true}
                        compact={false}
                        options={Object.values(members)}
                        task={imTask}
                        type={task.type}
                        canChangeProgress={false}
                        projectMembers={this.projectMembersId}
                        projectName={project ? project.name : undefined}
                        allowAdd={true}
                      />
                    </div>
                  )}
                  <div style={{ display: 'flex' }}>
                    {task.haveStartDate ? (
                      task.haveDueDate ? (
                        task.dateAndTime ? (
                          <MultiDatePicker
                            isEditable={true}
                            hasTime={true}
                            isWithDuration={true}
                            label={`${task.requiredFields?.includes('startDate') || listOfRequiredFields?.includes('dueDate') ? '*' : ''} ${
                              task?.startDateTitle
                                ? task?.startDateTitle
                                : (i18n.t('startDate', {
                                    ns: 'taskManager',
                                  }) as string)
                            }
                           - ${task?.dueDateTitle ? task.dueDateTitle : i18n.t('dueDate', { ns: 'taskManager' })}`}
                            value={{
                              startDate: task.startDate as number,
                              dueDate: task.dueDate as number,
                            }}
                            setDate={this.setDate}
                          />
                        ) : (
                          <MultiDatePicker_Range
                            isEditable={true}
                            hasTime={task.dateAndTime}
                            label={`${task.requiredFields?.includes('startDate') || listOfRequiredFields?.includes('dueDate') ? '*' : ''} ${
                              task?.startDateTitle
                                ? task?.startDateTitle
                                : i18n.t('startDate', { ns: 'taskManager' })
                            } - ${task?.dueDateTitle ? task?.dueDateTitle : i18n.t('dueDate', { ns: 'taskManager' })}`}
                            values={{
                              startDate: task.startDate as number,
                              dueDate: task.dueDate as number,
                            }}
                            setDate={this.setDate}
                          />
                        )
                      ) : (
                        <MultiDatePicker
                          isEditable={true}
                          hasTime={task.dateAndTime}
                          label={`${task.requiredFields?.includes('startDate') ? '*' : ''} ${
                            task?.startDateTitle
                              ? task.startDateTitle
                              : i18n.t('startDate', { ns: 'taskManager' })
                          }`}
                          value={task.startDate as number}
                          setDate={(value) => {
                            this.setDate({ startDate: value });
                          }}
                        />
                      )
                    ) : task.haveDueDate ? (
                      <MultiDatePicker
                        isEditable={true}
                        hasTime={task.dateAndTime}
                        label={`${task.requiredFields?.includes('dueDate') ? '*' : ''} ${
                          task?.dueDateTitle
                            ? task.dueDateTitle
                            : i18n.t('dueDate', { ns: 'taskManager' })
                        }`}
                        value={task.dueDate as number}
                        setDate={(value) => {
                          this.setDate({ dueDate: value });
                        }}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                </TaskItemBody>
              </TaskItem>
            </ItemWrapper>
            {expanded && (
              <TaskBody
                style={{
                  padding: '0rem 1rem',
                  overflow: 'visible',
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                }}
              >
                {fields
                  ?.filter(
                    (field) => !field.highlight && !field.relatedToProgress
                  )
                  .map((field, index) => {
                    return returnJSXOfFields(field, index);
                  })}
                {/* place relatedToProgress and highlight at the end of the list */}
                {fields
                  ?.filter(
                    (field) => field.relatedToProgress || field.highlight
                  )
                  .map((field, index) => {
                    return returnJSXOfFields(field, index);
                  })}
                <div style={{ flex: '1', flexBasis: '100%' }}>
                  {haveFollower && (
                    <UsersList>
                      <span
                        style={{
                          display: 'inline-block',
                          fontWeight: 'bold',
                          fontSize: '1rem',
                          paddingInlineStart: '0.25rem',
                          margin: '0.5rem 0',
                        }}
                      >
                        {`${task.requiredFields?.includes('follower') ? '*' : ''} ${messages.followers(followersTitle)}
                    `}
                      </span>
                      <UserSelector
                        usePop={true}
                        label={messages.followers(followersTitle)}
                        onChangeValues={this.handleChangeFollowers}
                        values={Object.values(followers).reduce(
                          (list: IUserOption[], value) => {
                            const userMember = members[
                              `USER_${value.userId}`
                            ] as IUserOption;
                            const item: IUserOption = {
                              userId: value.userId,
                              name: userMember.name,
                              progressDescription:
                                userMember.progressDescription,
                              roles: userMember.roles,
                              optionType: 'user',
                            };
                            list.push(item);
                            return list;
                          },
                          []
                        )}
                        options={Object.values(members)}
                        task={imTask}
                        type={'noAssignment'}
                        projectMembers={this.projectMembersId}
                        projectName={project ? project.name : undefined}
                        canChangeProgress={true}
                      />
                    </UsersList>
                  )}

                  {haveVerifier && (
                    <UsersList>
                      <span
                        style={{
                          display: 'inline-block',
                          fontWeight: 'bold',
                          fontSize: '1rem',
                          paddingInlineStart: '0.25rem',
                          margin: '0.5rem 0',
                          color: black,
                        }}
                      >
                        {`${task.requiredFields?.includes('verifier') ? '*' : ''} ${messages.verifier(verifierTitle)}
                    `}
                      </span>
                      <UserSelector
                        usePop={true}
                        label={messages.verifier(verifierTitle)}
                        onChangeValues={this.handleChangeVerifiers}
                        values={Object.values(task.verifiers).reduce(
                          (list: IUserOption[], value) => {
                            const userMember = members[
                              `USER_${value['userId']}`
                            ] as IUserOption;
                            const item: IUserOption = {
                              userId: value['userId'],
                              name: userMember?.name,
                              roles: userMember?.roles,
                              progress: value['progress'],
                              progressDescription: value.progressDescription,
                              optionType: 'user',
                              status: value['status']
                                ? value['status']
                                : 'notStarted',
                              relatedRoleId: value.properties?.roleId,
                              relatedRoleName: value.properties?.roleName,
                            };
                            list.push(item);
                            return list;
                          },
                          []
                        )}
                        options={Object.values(members).filter(
                          (option) => option.optionType === 'user'
                        )}
                        onChangeProgress={this.handleChangeVerifyProgress}
                        task={imTask}
                        type={'noAssignment'}
                        canChangeProgress={true}
                      />
                    </UsersList>
                  )}

                  {haveTaskPublisher && (
                    <UsersList>
                      <span
                        style={{
                          display: 'inline-block',
                          fontWeight: 'bold',
                          fontSize: '1rem',
                          paddingInlineStart: '0.25rem',
                          margin: '0.5rem 0',
                          color: black,
                        }}
                      >
                        {`${task.requiredFields?.includes('publisher') ? '*' : ''} ${messages.taskPublisher(taskPublisherTitle)}
                    `}
                      </span>
                      <UserSelector
                        usePop={true}
                        label={taskMessages.taskPublisher(taskPublisherTitle)}
                        onChangeValues={this.handleChangeVerifier(
                          'taskPublish',
                          'taskPublisher'
                        )}
                        values={
                          taskPublisher
                            ? [
                                {
                                  userId: taskPublisher.userId,
                                  name: members[`USER_${taskPublisher.userId}`]
                                    .name,
                                  progressDescription:
                                    taskPublisher.progressDescription,
                                  roles: (
                                    members[
                                      `USER_${taskPublisher.userId}`
                                    ] as IUserOption
                                  ).roles,
                                  optionType: 'user',
                                },
                              ]
                            : []
                        }
                        options={Object.values(members).filter(
                          (option) => option.optionType === 'user'
                        )}
                        onChangeProgress={this.handleChangeVerifyProgress}
                        singleChoice={true}
                        task={imTask}
                        type={'noAssignment'}
                        canChangeProgress={true}
                      />
                    </UsersList>
                  )}
                  {haveSubTaskPublisher && (
                    <UsersList>
                      <span
                        style={{
                          display: 'inline-block',
                          fontWeight: 'bold',
                          fontSize: '1rem',
                          paddingInlineStart: '0.25rem',
                          margin: '0.5rem 0',
                          color: black,
                        }}
                      >
                        {`${task.requiredFields?.includes('subtaskPublisher') ? '*' : ''} ${messages.subTaskPublisher(subTaskPublisherTitle)}`}
                      </span>
                      <UserSelector
                        usePop={true}
                        label={taskMessages.subTaskPublisher(
                          subTaskPublisherTitle
                        )}
                        onChangeValues={this.handleChangeVerifier(
                          'subTaskPublish',
                          'subTaskPublisher'
                        )}
                        values={
                          subTaskPublisher
                            ? [
                                {
                                  userId: subTaskPublisher.userId,
                                  name: members[
                                    `USER_${subTaskPublisher.userId}`
                                  ].name,
                                  progressDescription:
                                    subTaskPublisher.progressDescription,
                                  roles: (
                                    members[
                                      `USER_${subTaskPublisher.userId}`
                                    ] as IUserOption
                                  ).roles,
                                  optionType: 'user',
                                },
                              ]
                            : []
                        }
                        options={Object.values(members).filter(
                          (option) => option.optionType === 'user'
                        )}
                        onChangeProgress={this.handleChangeVerifyProgress}
                        singleChoice={true}
                        task={imTask}
                        type={'noAssignment'}
                        canChangeProgress={true}
                      />
                    </UsersList>
                  )}
                  {relatedProviders &&
                    (relatedProviderItems || haveRelatedItem) && (
                      <TaskFilePicker
                        items={relatedProviderItems}
                        onRemove={this.handleRemoveProviderItem}
                        onSave={this.handleSaveRelatedProviderItems}
                        providers={relatedProviders}
                        title={relatedProviderItemTitle}
                        editable={true}
                      />
                    )}
                </div>
              </TaskBody>
            )}
          </TaskWrapper>
        )}
        <TemplateDropdownWrapper>
          {availableTemplates.length > 0 && (
            <span style={{ display: 'inline-block' }}>
              <Button
                disabled={
                  adding &&
                  ((task ? !task.title : false) ||
                    (hasEmptyRequiredField &&
                      !task.draft &&
                      checkRequiredFieldsFulfilled()))
                }
                style={{ margin: '1rem 1rem 1rem 0rem' }}
                onClick={() =>
                  this.handleAddSubTask(
                    task && task.templateId
                      ? task.templateId
                      : availableTemplates.length === 1
                        ? availableTemplates[0].id
                        : undefined
                  )
                }
                color="green"
                loading={loadingSave}
              >
                {task && task.templateId
                  ? messages.saveAndAddASubtask(task.taskName)
                  : availableTemplates.length === 1
                    ? messages.addASubtask(availableTemplates[0].title)
                    : messages.addASubtask(parent.subTasksTitle)}
              </Button>
            </span>
          )}
          {availableTemplates.length > 1 && (
            <Dropdown
              target={
                <Button
                  disabled={
                    adding &&
                    ((task ? !task.title : false) ||
                      (hasEmptyRequiredField && !task.draft))
                  }
                  color="green"
                >
                  <Icon type="chevron-down" />
                </Button>
              }
              onShowChange={this.handleShowDropdown}
              show={this.state.showDropdown}
              curveBorder={true}
              marginToTarget={6}
              placement="bottom-start"
            >
              <Menu>
                {availableTemplates.map((t: any) => (
                  <MenuItem key={t.id}>
                    <a
                      href="#!"
                      data-template-id={t.id}
                      onClick={this.handleClickOnTemplateItem}
                    >
                      {t.title}
                    </a>
                  </MenuItem>
                ))}
              </Menu>
            </Dropdown>
          )}
        </TemplateDropdownWrapper>
      </div>
    );
  }
}

const mapStateToProps: MapStateToProps<StateToProps, IOwnProps, RootState> = (
  state,
  props
) => {
  const users = state.users.map;
  const companyId = Number(props.companyId);
  const company = state.companies.data[companyId];
  const companyRoles = company.roles;
  const relatedProviders = state.companies.data[companyId].relatedProviders;
  const token = getAccessToken(state);

  return {
    token,
    company,
    users,
    relatedProviders,
    companyRoles,
  };
};

const mapDispatchToProps: MapDispatchToProps<
  DispatchToProps,
  IOwnProps
> = () => ({
  createTask: (task: ITask, dontSendMessages?: boolean) =>
    appDispatch(createTask({ task, dontSendMessages })),
});

export default connect(mapStateToProps, mapDispatchToProps)(TaskListNew);
